import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { CookieService } from 'src/app/customServices/cookie.service';
import { KbExportToXlsxService } from 'src/app/services/feature/ExportCsv/kb-export-csv.service';
import { KbOpenPositionService } from 'src/app/services/feature/kb-open-position/kb-open-position.service';

@Component({
  selector: 'kb-open-position',
  templateUrl: './kb-open-position.component.html',
  styleUrls: ['./kb-open-position.component.scss'],
  standalone: false
})
export class KbOpenPositionComponent implements OnInit {
  showCustomerList = false;
  selectedCustomerId: any;
  openPositionData$: Observable<any> = this.kbOpenPositionService.getOpenPosition();
  openPositionData: any;
  canLoadPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  today = new Date();
  lastWeek = new Date(new Date().setDate(this.today.getDate() - 7));
  searchItemsList: any;
  sortBy = 'byDateDesc';
  paginationPage = 0;
  bsConfigFormat: string = 'DD.MM.YYYY';
  resultDateFormat: string = 'dd/MM/YYYY';
  private destroy$ = new Subject<void>();
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  searchOpenPositionForm = new FormGroup({
    defaultSoldTo: new FormControl(''),
    poNumber: new FormControl(''),
    orderNo: new FormControl(''),
    startDate: new FormControl(null, { validators: Validators.required }),
    endDate: new FormControl(null, { validators: Validators.required }),
    partNo: new FormControl(''),
    showCoworkersOrder: new FormControl(false),
  });

  @HostListener('keydown.escape')
  @HostListener('document:click')
  onDocumentClick() {
    this.showCustomerList = false;
  }

  selectedCustomerUnit(event) {
    this.showCustomerList = false;
    this.selectedCustomerId = event;
  }

  constructor(
    private kbOpenPositionService: KbOpenPositionService,
    private cd: ChangeDetectorRef,
    private excelService: KbExportToXlsxService,
    private cookieService: CookieService
  ) { }

  ngOnInit() {
    this.openPositionData$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.openPositionData = data;
      this.searchOpenPositionForm.controls['showCoworkersOrder'].setValue(data?.showCoworkersOrder)
      this.bsConfigFormat = this.openPositionData.dateFormat.toUpperCase();
      this.resultDateFormat = this.openPositionData?.dateFormat;
      this.selectedCustomerId = this.cookieService.getCookieValue(`customerIdNA`);
      const customer = data.b2bunits.find((item) => item.uid === this.selectedCustomerId);

      this.kbOpenPositionService.openPositionForm$.pipe(takeUntil(this.destroy$)).subscribe((formData) => {
        if (formData) {
          this.searchOpenPositionForm.patchValue({
            defaultSoldTo: formData?.defaultSoldTo,
            startDate: formData.startDate,
            endDate: formData.endDate,
            poNumber: formData.poNumber,
            orderNo: formData.orderNo,
            partNo: formData.partNo,
            showCoworkersOrder: formData.showCoworkersOrder,
          });

        } else {
          this.searchOpenPositionForm.patchValue({
            defaultSoldTo: customer?.uid,
            startDate: this.lastWeek,
            endDate: this.today,
          });
          this.kbOpenPositionService
            .searchOpenPositions(this.searchOpenPositionForm.getRawValue(), 0, 'byDateDesc')
            .pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
              this.searchItemsList = data;
              // this.resultDateFormat = data?.dateFormat
              this.cd.detectChanges();
            });
        }
      });
      this.canLoadPage.next(true);
      this.selectedCustomerId = customer.uid;
      this.cd.detectChanges();
    });
  }

  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showCustomerList = !this.showCustomerList;
  }

  onSearchItemsList() {
    if (!this.searchOpenPositionForm.valid) {
      return;
    }
    if (!this.searchOpenPositionForm.controls['defaultSoldTo'].value) {
      this.searchOpenPositionForm.controls['defaultSoldTo'].patchValue(this.cookieService.getCookieValue('customerIdNA'))
    }
    this.kbOpenPositionService.openPositionForm$.next(this.searchOpenPositionForm.getRawValue());
    const payload = {
      "defaultSoldTo": this.searchOpenPositionForm.controls['defaultSoldTo'].value,
      "startDate": this.searchOpenPositionForm.controls['startDate'].value,
      "endDate": this.searchOpenPositionForm.controls['endDate'].value,
      "poNumber": this.searchOpenPositionForm.controls['poNumber'].value?.trim() || '',
      "orderNo": this.searchOpenPositionForm.controls['orderNo'].value?.trim() || '',
      "partNo": this.searchOpenPositionForm.controls['partNo'].value?.trim() || '',
      "showCoworkersOrder": this.searchOpenPositionForm.controls['showCoworkersOrder']?.value || false
    }
    this.kbOpenPositionService
      .searchOpenPositions(payload, 0, 'byDateDesc')
      .pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.searchItemsList = data;
        this.cd.detectChanges();
      });
  }

  onCustomerSelect(event: any) {
    this.selectedCustomerId = event.target.value;
    this.searchOpenPositionForm.patchValue({ defaultSoldTo: event.target.value });
  }

  sort(event) {
    this.sortBy = event;
    this.kbOpenPositionService
      .searchOpenPositions(this.searchOpenPositionForm.getRawValue(), this.paginationPage, this.sortBy)
      .pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.searchItemsList = data;
        this.cd.detectChanges();
      });
  }

  page(event) {
    this.paginationPage = event;
    this.kbOpenPositionService
      .searchOpenPositions(this.searchOpenPositionForm.getRawValue(), this.paginationPage, this.sortBy)
      .pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.searchItemsList = data;
        this.cd.detectChanges();
      });
  }

  exportToExcelFile(event) {
    this.kbOpenPositionService.exportExcelMyHistory(this.searchOpenPositionForm.value).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res?.kbStatusMessageWSDTO?.status == 'SUCCESS') {
        this.excelService.exportDataToExcel(res?.fileMedia, 'openPositions');
      }
    });
  }

  reset() {
    this.timeout = setTimeout(() => {
      this.searchOpenPositionForm.controls['defaultSoldTo'].patchValue(this.cookieService.getCookieValue('customerIdNA'))
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();


    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

}
